import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { twMerge } from "tailwind-merge";
import { Badge } from "@components/Badge/Badge";
import { ChevronIcon, HouseIcon } from "@components/icons";

interface ILargeAccordionProps {
  title: string | React.ReactNode;
  isDefaultOpen?: boolean;
  badge?: React.ReactNode;
  children?: React.ReactNode;
}

export const LargeAccordion: React.FC<ILargeAccordionProps> = ({
  title,
  isDefaultOpen,
  badge,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(isDefaultOpen);

  return (
    <div className="flex min-h-[103px] flex-col divide-y divide-grey-light overflow-hidden rounded-2xl border border-grey-light">
      <>
        <div className="flex items-center gap-4 p-6">
          <button onClick={() => setIsOpen((prev) => !prev)}>
            <ChevronIcon
              className={twMerge(
                "size-5 transition-transform",
                isOpen && "rotate-180",
              )}
            />
          </button>
          {badge ?? (
            <Badge
              icon={HouseIcon}
              className="hidden bg-blue-dark md:flex"
              iconClassName="text-base-white"
              size="large"
              variant="rounded"
            />
          )}
          <span className="text-xl font-semibold">{title}</span>
        </div>
        <AnimatePresence>
          {isOpen && (
            <motion.div
              className="flex flex-col"
              initial={{ opacity: 0, y: -24, height: 0 }}
              animate={{ opacity: 1, y: 0, height: "auto" }}
              exit={{ opacity: 0, y: -24, height: 0 }}
              transition={{ duration: 0.3 }}
            >
              {children}
            </motion.div>
          )}
        </AnimatePresence>
      </>
    </div>
  );
};
